import { useIntl } from 'react-intl'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import useSaleUnitFormatting from 'hooks/useSaleUnitFormatting'

interface Props {
  saleUnit: string
}

function PreSelectionBanner({ saleUnit }: Props) {
  const intl = useIntl()
  const { formatSaleUnitLabel, getSaleUnitPluralNoun } = useSaleUnitFormatting()

  const localizedSaleUnit = formatSaleUnitLabel(saleUnit)

  return (
    <MessageBanner
      kind="promotional"
      density="compact"
    >
      {intl.formatMessage(
        {
          id: 'VlZDqde2ceMwvtQv4flm',
          defaultMessage: 'We’ve pre-selected the best-value {pluralSaleUnit} to get you started. Customise each {saleUnit} below.',
          description: 'Banner message explaining auto-selected best-value room packages',
        },
        {
          pluralSaleUnit: getSaleUnitPluralNoun(saleUnit),
          saleUnit: localizedSaleUnit,
        },
      )}
    </MessageBanner>
  )
}

export default PreSelectionBanner
